module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"header":"Send an email","sendError":"Something went wrong and we couldn\u0027t send your email. Please try again.","successMessage":"Email sent"}}')
  delete Component.options._Ctor
}
